import { Flex, Icon, Text } from '@chakra-ui/react'
import { AirportIcon } from 'components/icons/airportIcon'
import { IncrementalSearchResponseData } from 'generated/graphql'
import { FC } from 'react'
import { MdBusiness, MdLocationPin, MdTrain } from 'react-icons/md'

type Props = {
  data: IncrementalSearchResponseData
  onClick: () => any
}

export const formatIncrementalSearchLocation = (data: IncrementalSearchResponseData): string | undefined => {
  const location = data.location?.trim()
  if (!location) return undefined
  const name = data.name.trim()
  if (!location.startsWith(name)) return location
  const nextChar = location.charAt(name.length)
  if (nextChar && !/[\s,、，]/.test(nextChar)) return location

  const withoutName = location
    .slice(name.length)
    .replace(/^[\s,、，]+/, '')
    .trim()
  return withoutName.length > 0 ? withoutName : undefined
}

export const IncrementalSearchListItem: FC<Props> = ({ data, onClick }) => {
  const location = formatIncrementalSearchLocation(data)

  return (
    <Flex key={data.id} alignItems="center" py={2} px={3} cursor="pointer" _hover={{ background: 'blue.50' }} onClick={onClick}>
      <Icon
        as={(() => {
          switch (data.type) {
            case 'train_station':
              return MdTrain
            case 'airport':
              return AirportIcon
            case 'property_content':
              return MdBusiness
            default:
              return MdLocationPin
          }
        })()}
        w={6}
        h={6}
        color="blue.500"
      />
      <Flex direction="column" ml="4">
        <Text fontWeight="bold">{data.name}</Text>
        {location && <Text>{location}</Text>}
      </Flex>
    </Flex>
  )
}
